// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__GOZSo","header":"Messages_header__1zxsV"};